<template>
  <div class="container">
    <BasicTitle title="Nueva Desvinculación" />
    <BasicSubtitle subtitle="Los campos señalados con (*) son obligatorios." />
    <div class="container-form">
      <BasicLabel label="Usuario Personal *" />
      <BorderSelect
        v-model="unlink.data.personnelId"
        label="Usuario Personal *"
        :options="store.state.personnel.personnelList"
      />
      <FormError
        :show="unlink.rules.personnelId"
        message="Seleccione un usuario personal"
      />
      <BasicLabel label="Comentarios" />
      <OutlinedTextArea v-model="unlink.data.comments" />
      <FormError />
      <BorderFile :v-model="unlink.selectedDocuments" @select="onSelectFiles" />
      <FormError
        :show="unlink.rules.selectedDocuments"
        message="Debe adjuntar un documento"
      />
    </div>
    <PrimaryButton label="Guardar" :click="onSave" />
  </div>
</template>

<script>
import BasicTitle from "../../widgets/title/BasicTitle";
import BasicLabel from "../../widgets/label/BasicLabel";
import BasicSubtitle from "../../widgets/subtitle/BasicSubtitle";
import BorderInput from "../../widgets/input/BorderInput";
import BorderSelect from "../../widgets/select/BorderSelect";
import BorderInputPrefix from "../../widgets/input/BorderInputPrefix";
import BorderInputPhone from "../../widgets/input/BorderInputPhone";
import FormError from "../../widgets/error/FormError";
import PrimaryButton from "../../widgets/button/PrimaryButton";
import BorderDate from "../../widgets/calendar/BorderDate.vue";
import BorderTime from "../../widgets/calendar/BorderTime.vue";
import OutlinedTextArea from "../../widgets/textarea/OutlinedTextArea.vue";
import store from "../../store";
import { onBeforeMount, onBeforeUnmount, reactive, watchEffect } from "vue";
import { useRouter, useRoute } from "vue-router";
import { openMode } from "../../constants";
import { validation, actions, aws } from "../../constants";
import BorderFile from "../../widgets/file/BorderFile.vue";

export default {
  components: {
    BasicTitle,
    BasicLabel,
    BasicSubtitle,
    BorderInput,
    BorderSelect,
    BorderInputPrefix,
    BorderInputPhone,
    BorderDate,
    BorderTime,
    FormError,
    PrimaryButton,
    BorderFile,
    OutlinedTextArea,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const unlink = reactive({
      selectedDocuments: [],
      data: {
        id: -1,
        personnelId: "",
        comments: "",
      },
      rules: {
        personnelId: false,
        selectedDocuments: false,
      },
    });

    const onSelectFiles = (ev) => {
      unlink.selectedDocuments = ev.files;
    };

    const validate = () => {
      let valid = true;

      if (!unlink.data.personnelId) {
        unlink.rules.personnelId = true;
        valid = false;
      }
      if (!unlink.selectedDocuments.length) {
        unlink.rules.selectedDocuments = true;
        valid = false;
      }

      return valid;
    };

    const onSave = async () => {
      if (!validate()) return;

      store.commit("setLoading", true);

      const responsePath = await store.dispatch(
        actions.documentActions.getPath,
        {
          buildingId: store.state.general.selectedBuilding,
          folderName: "Desvinculaciones",
          documentTypeName: "Desvinculaciones",
        }
      );

      if (responsePath.ok) {
        let count = 0;
        const documents = [];
        const { length } = unlink.selectedDocuments;
        const finish = async () => {
          const request = {
            id: unlink.data.id,
            personnelId: unlink.data.personnelId,
            buildingId: store.state.general.selectedBuilding,
            comments: unlink.data.comments,
            documents,
          };

          const response = await store.dispatch(
            actions.unlinkActions.create,
            request
          );
          store.commit("setLoading", false);
          if (response.ok) {
            store.commit("setSelectedUnlinkList", []);
            router.push("/desvinculaciones/listado");
          } else {
            alert(response.message);
          }
        };

        if (count === length) finish();

        unlink.selectedDocuments.forEach(async (doc) => {
          const name = doc.name;
          const key = `${responsePath.path}${name}`;
          const uploaded = async () => {
            documents.push({
              path: responsePath.path,
              name: name
                .split(".")
                .slice(0, -1)
                .join("."),
              ext: validation.extensionRegex.exec(name)[0],
            });

            count += 1;
            if (count === length) finish();
          };
          aws.uploadFile(key, doc, uploaded);
        });
      } else {
        store.state.toast.add({
          severity: "error",
          summary: "",
          detail: responsePath.message,
          life: 5000,
        });
      }
    };

    onBeforeMount(async () => {
      if (!store.state.openMode) router.push("/desvinculaciones/listado");
      store.commit("addBreadcrumb", { label: route.name, to: route.path });
      store.commit("setLoading", true);
      await store.dispatch(
        actions.personnelActions.findAll,
        store.state.general.selectedBuilding
      );
      store.commit("setLoading", false);
    });

    onBeforeUnmount(() => {
      store.commit("removeBreadcrumb");
    });

    watchEffect(() => {
      if (unlink.data.personnelId) unlink.rules.personnelId = false;
      if (unlink.selectedDocuments.length)
        unlink.rules.selectedDocuments = false;
    });

    return { store, unlink, onSave, onSelectFiles };
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
}
.link-label {
  margin-right: 1rem;
  font-family: "klavika";
  color: var(--primary);
}
</style>
